import React from 'react'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import {
  FieldNames,
  RecurrenceTypes,
  PeriodTypes,
  IntradayRepeatTypes,
} from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { getFormattedDateInUTC } from '../../../services/date'
import { DATE_FORMATS } from '../../../config'
import { usePublishSchedule } from '../hooks'
import { P } from '../../StyledText'

export const UTC = () => {
  const [{ fieldValues }, dispatch] = usePublishSchedule()
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            id="auto-utc-checkbox"
            color="primary"
            checked={fieldValues.utc}
            onChange={() => {
              dispatch(setFieldValue(FieldNames.utc, !fieldValues.utc))
            }}
          />
        }
        label="Show dates in UTC"
      />
      {fieldValues.utc && (
        <>
          {!!fieldValues.startTime && (
            <P className="auto-utc-start-time">
              Start time: {getFormattedDateInUTC(fieldValues.startTime)}
            </P>
          )}
          {!!fieldValues.endTime &&
            fieldValues.recurrence !== RecurrenceTypes.none &&
            fieldValues.period === PeriodTypes.untilDate && (
              <P className="auto-utc-end-time">
                End time: {getFormattedDateInUTC(fieldValues.endTime)}
              </P>
            )}
          {!!fieldValues.intradayRepeatUntil &&
            fieldValues.intradayRepeat === IntradayRepeatTypes.repeat && (
              <P className="auto-utc-intraday-until">
                Intraday repeat until:{' '}
                {getFormattedDateInUTC(
                  fieldValues.intradayRepeatUntil,
                  DATE_FORMATS.TIME_ONLY
                )}
              </P>
            )}
        </>
      )}
    </>
  )
}
